export enum ADDRESS_LOADING_MESSAGES {
  retrievingAddresses = `We're retrieving addresses...`,
  retrievingAddress = `We're retrieving this address...`,
}
